import { onMounted, ref, useTemplateRef, watch } from 'vue';

/** @deprecated */
export function useWrapper(wrapperKey: string) {
  const wrapper = useTemplateRef<HTMLElement>(wrapperKey);
  const parentStepId = ref<string | null>(null);

  onMounted(() => {
    parentStepId.value = wrapper.value?.closest('.product-config-step ')?.id ?? '';
  });

  watch(wrapper, (wrapperElement) => {
    parentStepId.value = wrapperElement?.closest('.product-config-step ')?.id ?? '';
  });

  return { wrapper, parentStepId };
}
